import React, { createContext, useContext, useRef } from 'react';

const ServicesSectionContext = createContext(null);

export const useServicesSection = () => {
    return useContext(ServicesSectionContext);
};

export const ServicesSectionProvider = ({ children }) => {
    const servicesSectionRef = useRef(null);

    return (
        <ServicesSectionContext.Provider value={servicesSectionRef}>
            {children}
        </ServicesSectionContext.Provider>
    );
};

